import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';

import { IcBellSlash16, MentionIcon, Pin2Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { Badge, Button, IconView, IconViewSizes } from '@gem/ui-kit';

import { GroupStatus } from 'APP/main/components/GroupStatus/GroupStatus';
import { Group } from 'STORE/Groups/Group';

import { GroupDescription } from '../../components/GroupDescription/GroupDescription';
import { GroupListItem } from '../../components/GroupListItem/GroupListItem';
import { JoinCallButton } from '../../components/JoinCallButton/JoinCallButton';
import { useGroupItemPresenter } from './GroupItem.presenter';
import styles from './GroupItem.styles.m.css';

interface IGroupItemProps {
  group: Group;
  isShowSpaceIcon: boolean;
}

export const GroupItem: FC<IGroupItemProps> = observer(({ group, isShowSpaceIcon }) => {
  const presenter = useGroupItemPresenter(group);
  const { t } = useTranslation();

  return (
    <GroupListItem
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      group={group}
      isShowSpaceIcon={isShowSpaceIcon}
      isIconsCentered={
        !!presenter.backgroundCall ||
        presenter.isBlockedSecretChat ||
        presenter.hasSecretChatAccessRequest
      }
      description={
        presenter.isBlockedSecretChat ? (
          <div className={styles.blockedDescription}>{t('secure_chat_status_locked')}</div>
        ) : (
          <GroupStatus
            group={group}
            className={styles.status}
          >
            <GroupDescription group={group} />
          </GroupStatus>
        )
      }
      badges={
        presenter.isBlockedSecretChat ? (
          <Button
            className={styles.unlockButton}
            theme="secondary"
            size="0"
            onClick={presenter.onSecureChatUnlockClick}
          >
            {t('secure_chat_unlock_button')}
          </Button>
        ) : (
          <>
            {presenter.hasMention && <MentionIcon className={styles.mention} />}
            {presenter.hasSecretChatAccessRequest && (
              <IconView
                Icon={IcBellSlash16}
                size={IconViewSizes.Small}
                className={styles.bellIcon}
              />
            )}
            {presenter.hasUnread && (
              <Badge
                quantity={presenter.numberOfUnread || null}
                isMuted={group.muted}
              />
            )}
            {presenter.hasPinedIcon && <Pin2Icon className={styles.pin} />}
            {!!presenter.backgroundCall && (
              <JoinCallButton
                hasActiveCall={!!presenter.activeCall}
                startTs={Number(presenter.activeCall?.startTs) || 0}
                onClick={presenter.onJoinToCall}
              />
            )}
          </>
        )
      }
    />
  );
});
